export const countries = [
  {value: 'AR', name: 'Argentina'},
  {value: 'CO', name: 'Colombia'},
  {value: 'MX', name: 'Mexico'},
  {value: 'BR', name: 'Brasil'},
  {value: 'CL', name: 'Chile'}
]
